(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  if (!customElements.get('password-stage')) {
    class PasswordStage extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.cleanups = [];
        this.fitWord();
        this.spotlight();
        this.countdown();
        this.clock();
        this.magnetic();
      }

      disconnectedCallback() {
        this.cleanups.forEach((fn) => fn());
      }

      /* scale the wordmark so it always spans the width without overflowing */
      fitWord() {
        const word = this.querySelector('[data-pw-word]');
        if (!word) return;
        const fit = () => {
          word.style.fontSize = '100px';
          const available = word.clientWidth;
          const natural = word.scrollWidth;
          if (!natural) return;
          const size = Math.min((100 * available) / natural, window.innerHeight * 0.34, 320);
          word.style.fontSize = Math.max(40, size * 0.985) + 'px';
        };
        fit();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
        const ro = new ResizeObserver(fit);
        ro.observe(this);
        this.cleanups.push(() => ro.disconnect());
      }

      /* cursor spotlight (eased); on touch it drifts slowly on its own */
      spotlight() {
        if (!this.classList.contains('pw--spot')) return;
        const pos = { x: 0.5, y: 0.45, tx: 0.5, ty: 0.45 };
        const set = () => {
          this.style.setProperty('--pw-x', (pos.x * 100).toFixed(2) + '%');
          this.style.setProperty('--pw-y', (pos.y * 100).toFixed(2) + '%');
        };
        if (this.reduce) return set();
        let raf = 0;
        let t0 = performance.now();
        let lastMove = 0;
        const loop = (now) => {
          if (!this.fine || now - lastMove > 4000) {
            const t = (now - t0) / 1000;
            pos.tx = 0.5 + Math.sin(t * 0.35) * 0.28;
            pos.ty = 0.45 + Math.sin(t * 0.52 + 1) * 0.18;
          }
          pos.x += (pos.tx - pos.x) * 0.08;
          pos.y += (pos.ty - pos.y) * 0.08;
          set();
          raf = requestAnimationFrame(loop);
        };
        const onMove = (e) => {
          const r = this.getBoundingClientRect();
          pos.tx = (e.clientX - r.left) / r.width;
          pos.ty = (e.clientY - r.top) / r.height;
          lastMove = performance.now();
        };
        if (this.fine) this.addEventListener('pointermove', onMove, { passive: true });
        const io = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && !raf) raf = requestAnimationFrame(loop);
          if (!entry.isIntersecting && raf) {
            cancelAnimationFrame(raf);
            raf = 0;
          }
        });
        io.observe(this);
        this.cleanups.push(() => {
          io.disconnect();
          cancelAnimationFrame(raf);
          this.removeEventListener('pointermove', onMove);
        });
      }

      /* live countdown; hidden when no valid future date is set */
      countdown() {
        const box = this.querySelector('[data-pw-count]');
        const raw = (this.dataset.launch || '').trim();
        if (!box || !raw) return;
        const end = Date.parse(raw);
        if (isNaN(end) || end <= Date.now()) return;
        box.hidden = false;
        const els = {
          d: box.querySelector('[data-pw-d]'),
          h: box.querySelector('[data-pw-h]'),
          m: box.querySelector('[data-pw-m]'),
          s: box.querySelector('[data-pw-s]'),
        };
        const pad = (n) => String(n).padStart(2, '0');
        const put = (el, v) => {
          if (el.textContent === v) return;
          el.textContent = v;
          if (this.reduce) return;
          el.classList.remove('is-tick');
          void el.offsetWidth;
          el.classList.add('is-tick');
        };
        const tick = () => {
          const left = Math.max(0, end - Date.now()) / 1000;
          put(els.d, pad(Math.floor(left / 86400)));
          put(els.h, pad(Math.floor((left % 86400) / 3600)));
          put(els.m, pad(Math.floor((left % 3600) / 60)));
          put(els.s, pad(Math.floor(left % 60)));
          if (left <= 0) clearInterval(timer);
        };
        const timer = setInterval(tick, 1000);
        tick();
        this.cleanups.push(() => clearInterval(timer));
      }

      /* local time in the corner */
      clock() {
        const el = this.querySelector('[data-pw-clock]');
        if (!el) return;
        const fmt = () => {
          const d = new Date();
          el.textContent = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
        };
        fmt();
        const timer = setInterval(fmt, 15000);
        this.cleanups.push(() => clearInterval(timer));
      }

      /* buttons lean toward the cursor */
      magnetic() {
        if (!this.fine || this.reduce) return;
        this.querySelectorAll('.pw__blocks button, .pw__blocks .button').forEach((b) => {
          b.style.transition = 'transform .5s cubic-bezier(.16,1,.3,1)';
          const move = (e) => {
            const r = b.getBoundingClientRect();
            b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.25}px, ${(e.clientY - r.top - r.height / 2) * 0.35}px)`;
          };
          const leave = () => (b.style.transform = '');
          b.addEventListener('pointermove', move);
          b.addEventListener('pointerleave', leave);
          this.cleanups.push(() => {
            b.removeEventListener('pointermove', move);
            b.removeEventListener('pointerleave', leave);
          });
        });
      }
    }
    customElements.define('password-stage', PasswordStage);
  }

  } catch(e) { console.error(e); }
})();
})();
